import axios from '@/http/axios'
import {createCancelTokenHandler, makeQuery} from '../axios/utils'

const cancelTokenHandlerObject = {
  getTasks: createCancelTokenHandler('getTasks')
}


export function getCategories () {
  return axios({
    url: 'v1/categories',
    method: 'get'
  })
}

export function getTasks (page = 1, filters = {}, sorts = []) {
  let queries = makeQuery(page, filters, sorts)
  //simple filters ['name=ali', 'createdAt=1399/03/05']
  //simple sorts ['order[0]=fullName,desc']

  if (queries.length > 0) queries = `?${  queries.join('&')}`

  return axios({
    url: `v1/tasks${queries}`,
    method: 'get',
    cancelToken: cancelTokenHandlerObject['getTasks'].handleRequestCancellation().token
  })
}

export function getTask (id, loading) {
  return axios({
    url: `v1/tasks/${id}`,
    method: 'get',
    loading
  })
}

export function insertUserTask (data) {
  return axios({
    url: 'v1/tasks',
    data,
    method: 'post'
  })
}

export function editTask (payment) {
  return axios.patch(`v1/tasks/${payment.id}`, payment)
}

export function acceptTask (id, data) {
  return axios({
    url: `v1/tasks/${id}/accept`,
    data,
    method: 'post'
  })
}
